import { useNavigate } from "react-router-dom";
import {
  Badge,
  Button,
  Divider,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Tooltip,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import { ReactComponent as BellSvg } from "assets/Svgs/bell.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useEffect, useState } from "react";
import { ReactComponent as AvatarSvg } from "assets/Svgs/avatar.svg";
import { useBoundStore } from "store/store";
import Avatar from "@mui/material/Avatar";
import i18n from "i18n/i18n";

function Header() {
  const navigate = useNavigate();
  const logOut = useBoundStore((state) => state.logOut);

  const isAdmin = useBoundStore((state) => state.isAdmin);

  const [profileSettingsAnchor, setProfileSettingsAnchor] =
    useState<null | HTMLElement>(null);

  const user: any = useBoundStore((state) => state.user);

  const lang: any = useBoundStore((state) => state.lang);


  return (
    <div className="headerWrapper">
      <div className="searchBar">
      
      </div>
      <div className="bellWrapper">
       
        <div className="profileMenu">
          <div className={"accountContainer"}>
            <List className={"roundedListItems"} dense={true}>
              <ListItem
                onClick={(event) =>
                  setProfileSettingsAnchor(event.currentTarget)
                }
              >
                <ListItemAvatar>
                  <Avatar
                    alt={i18n(lang)?.heading_your_profile}
                    src={user?.image?.url || ""}
                    className="bxShadow"
                  />
                </ListItemAvatar>

                <Tooltip
                  title={
                    <div>
                      {user?.ismemberof &&
                        user?.ismemberof[0]?.legalentity.name}
                      <br />
                      {(user?.givenname ? user?.givenname : "") +
                        " " +
                        (user?.surname ? user?.surname : "")}
                    </div>
                  }
                >
                  <ListItemText
                    primary={
                      user?.ismemberof && user?.ismemberof[0]?.legalentity.name
                    }
                    secondary={
                      (user?.givenname ? user?.givenname : "") +
                      " " +
                      (user?.surname ? user?.surname : "")
                    }
                  />
                </Tooltip>

                {profileSettingsAnchor ? (
                  <ArrowDropUpIcon />
                ) : (
                  <ArrowDropDownIcon />
                )}
              </ListItem>
              <Menu
                className="profile-menu"
                style={{ marginTop: "-7px" }}
                anchorEl={profileSettingsAnchor}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
                keepMounted
                open={Boolean(profileSettingsAnchor)}
                onClose={() => setProfileSettingsAnchor(null)}
              >
                <MenuItem
                  onClick={() => {
                    setProfileSettingsAnchor(null);
                    navigate("/profile");
                  }}
                >
                  {i18n(lang).profile}
                </MenuItem>
                <Divider />
                <MenuItem
                  onClick={() => {
                    logOut();
                    navigate("/login");
                  }}
                >
                  {i18n(lang).logout}
                </MenuItem>
              </Menu>
            </List>
          </div>
        </div>

        {isAdmin ? (
          <Button
            style={{ margin: "0% 0% 0% 5%" }}
            className="cp"
            variant="text"
            onClick={() => {
              navigate("/users");
            }}
          >
             {i18n(lang).admin}
          </Button>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}

export default Header;
